import { render, staticRenderFns } from "./payments-balances-edit.vue?vue&type=template&id=0f77353a&"
import script from "./payments-balances-edit.vue?vue&type=script&lang=js&"
export * from "./payments-balances-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports